module.exports = __webpack_public_path__ + "static/media/gsNl3i_sm1.eecb8f70.png";